"use client";

import { Heart, House, Shield } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Features() {
  const {
    ref: ref1,
    isVisible: isVisible1
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const {
    ref: ref2,
    isVisible: isVisible2
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const {
    ref: ref3,
    isVisible: isVisible3
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const features = [{
    icon: Heart,
    color: "text-[hsl(350,78%,50%)]",
    title: "Qualified Care",
    description: "Our experienced team provides professional, compassionate support tailored to each individual's unique needs, ensuring the highest quality of care."
  }, {
    icon: House,
    color: "text-[hsl(40,88%,55%)]",
    title: "Exceptional Homes",
    description: "Modern, comfortable living spaces designed to promote independence and well-being in a safe, nurturing environment."
  }, {
    icon: Shield,
    color: "text-accent",
    title: "Ofsted Registered",
    description: "Fully regulated and inspected to meet the highest standards of care and safety for all our residents."
  }];
  const refs = [ref1, ref2, ref3];
  const visibilities = [isVisible1, isVisible2, isVisible3];
  return <section id="features" className="py-24 bg-background">
      <div className="container mx-auto px-6 max-w-7xl">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {features.map((feature, i) => {
          const Icon = feature.icon;
          return <div key={i} data-index={i} ref={refs[i]} className={`transition-all duration-[350ms] ease-[cubic-bezier(0.4,0,0.2,1)] ${visibilities[i] ? "opacity-100 translate-y-0" : "opacity-0 translate-y-[10px]"}`} style={{
            transitionDelay: `${i * 100}ms`
          }}>
                <Card className="h-full hover:-translate-y-[2px] hover:shadow-[0_4px_12px_rgba(0,0,0,0.15)] transition-all duration-[150ms] border border-border shadow-soft px-6">
                  <CardContent className="flex flex-col items-start gap-4">
                    <Icon className={`w-12 h-12 ${feature.color}`} strokeWidth={1.5} />
                    <h3 className="text-xl font-semibold text-accent leading-tight">
                      {feature.title}
                    </h3>
                    <p className="text-foreground text-base leading-relaxed">
                      {feature.description}
                    </p>
                  </CardContent>
                </Card>
              </div>;
        })}
        </div>
      </div>
    </section>;
}